import axiosInstance from '../axiosInstance';

const getPublic = async () => axiosInstance.get('/stats/public').then((response) => response.data);

const statsService = { getPublic };

export default statsService;
